var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#3AC09D",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 7H22.75C23.7165 7 24.5 7.7835 24.5 8.75H17.5C17.5 7.7835 18.2835 7 19.25 7ZM15.75 8.75C15.75 6.817 17.317 5.25 19.25 5.25H22.75C24.683 5.25 26.25 6.817 26.25 8.75H31.5C34.3995 8.75 36.75 11.1005 36.75 14V29.75C36.75 32.6495 34.3995 35 31.5 35H10.5C7.60051 35 5.25 32.6495 5.25 29.75V14C5.25 11.1005 7.60051 8.75 10.5 8.75H15.75ZM14.875 14C15.3582 14 15.75 14.3918 15.75 14.875L15.75 28.875C15.75 29.3582 15.3582 29.75 14.875 29.75C14.3918 29.75 14 29.3582 14 28.875V14.875C14 14.3918 14.3918 14 14.875 14ZM28 14.875C28 14.3918 27.6082 14 27.125 14C26.6418 14 26.25 14.3918 26.25 14.875L26.25 28.875C26.25 29.3582 26.6418 29.75 27.125 29.75C27.6082 29.75 28 29.3582 28 28.875V14.875Z",
    fill: "#3AC09D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJob);
export default __webpack_public_path__ + "static/media/icon-job.24abb027.svg";
export { ForwardRef as ReactComponent };